<template>
  <div class="detail">
    <div class="title">{{detail.title}}</div>
    <div class="time">{{detail.publishTime ? $moment(detail.publishTime).format('YYYY.MM.DD HH:mm') : ''}}</div>
    <div class="content" v-html="detail.content"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
    };
  },
  mounted() {
    this.getDetail(this.$route.query.newsId);
  },
  methods: {
    async getDetail(newsId) {
      const res = await this.$HTTP.ApiArticle.getNewsDetailGET({
        newsId: newsId,
      });
      console.log(res, "res");
      this.detail = res.data;
      this.detail.content = res.data.content.replace(/<img/g, '<img style="max-width: 100%;height: auto;"')
      document.title = this.detail.title
    },
  },
};
</script>

<style lang="less" scoped>
.detail {
  padding: 20px;
  .title {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #212b36;
  }
  .time {
    margin-top: 5px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #a2a6b8;
  }
  .content {
    margin-top: 23px;
    img {
      max-width: 100% !important;
      height: auto !important;
    }
  }
}
</style>